import React, {
	forwardRef,
	useEffect,
	useLayoutEffect,
	useRef,
	useState,
} from 'react';
import '../css/header.css';
import logo from '../assets/icons/logo_mini.svg';
import menu from '../assets/hamberger.png';
import close from '../assets/close.svg';
import { NavLink, useLocation } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import mypage_ico from '../assets/MobileUserIcon.png';
import logout_ico from '../assets/MobileLogout.png';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { translatedText } from '../recoil-states/language-state';
import profileImg from '../assets/profile_img_circle.png';
import { OAuthData } from '../recoil-states/user-state/user-OAuth';
import { WalletConnectModalOpen } from '../recoil-states/user-state/user-state';
import m_logo from '../assets/mobile_assets/icons/m_kctLogo.svg';
import m_profileIcon from '../assets/mobile_assets/icons/m_profileIcon.svg';
import default_profileImg from '../assets/default_profile.png';
import { decryptedData } from '../function/functions';
import { isMobile } from 'react-device-detect';
import { useAccount } from 'wagmi';

const HeaderMobile = forwardRef(
	(
		{
			colortype,
			setMypage,
			onChangelanguage,
			mypage,
			login,
			_myPageRoute,
			onLogin,
			oauthState,
			setModalopen,
			logoutFuc,
			staticModalStyles,
			windowy,
			handleAuth,
			address,
		},
		mobileHeaderRef
	) => {
		const [openMenu, setOpenMenu] = useState(false);
		const textData = useRecoilValue(translatedText);
		const [userData, setUserData] = useRecoilState(OAuthData);
		const loacalelang = localStorage.getItem('locale');
		const { isConnected } = useAccount();
		const [walletConnectmodal, setWalletConnectModal] = useRecoilState(
			WalletConnectModalOpen
		);
		const offModal = () => {
			setOpenMenu(false);
		};

		useEffect(() => {
			// onLogin();
			setOpenMenu(false);
		}, [oauthState]);

		return (
			<>
				<div
					className={
						window.scrollY > 0
							? 'mobile_header active'
							: 'mobile_header'
					}>
					<Row
						lg={12}
						// bg="black"
						// variant="dark"
						className={openMenu ? 'header_m black' : 'header_m'}
						ref={mobileHeaderRef}>
						<Col lg={12} className='header_container_m'>
							<NavLink to='/'>
								<div className='logo'>
									<img src={m_logo} />
									{<p>Konnect</p>}
								</div>
							</NavLink>
							<div className='user_menu_box'>
								<div className='user_profile_m'>
									<div className='login_box'>
										<div
											className='login_box_item'
											onClick={() => {
												!isConnected && handleAuth();
											}}>
											<img
												// src={userData?.profile_image_url ? userData?.profile_image_url : profileImg ?? profileImg}
												src={
													userData?.profile_image_url
														? userData?.profile_image_url
														: address
														? default_profileImg
														: m_profileIcon
												}
												className='login_box_img'
												onClick={() => {
													// 아이콘 클릭 시 로그인
													// return !isConnected ? handleAuth() : null
												}}
											/>
										</div>
									</div>
									{mypage === true ? (
										<div className='mypage_box_m'>
											<div>
												<img src={mypage_ico} />
												<div
													onClick={() => {
														_myPageRoute();
														setMypage(false);
													}}>
													<p className='mypage_boxtext_m'>
														My Page
													</p>
												</div>
											</div>
											<div
												onClick={() => {
													logoutFuc();
													setMypage(false);
												}}>
												<img src={logout_ico} />
												<p className='mypage_boxtext_m'>
													Log Out
												</p>
											</div>
										</div>
									) : null}
								</div>
								<div
									className='hamberger'
									onClick={() => {
										setOpenMenu(!openMenu);
										setMypage(false);
									}}>
									<img src={openMenu ? close : menu} />
								</div>
							</div>
						</Col>
					</Row>
					{openMenu ? (
						<div className='menu_list_m'>
							<ul>
								<NavLink to='/' className='menu_item_m'>
									<li onClick={offModal}>HOME</li>
								</NavLink>
								{isMobile ? (
									<NavLink
										to='/about'
										className='menu_item_m'>
										<li onClick={offModal}>ABOUT</li>
									</NavLink>
								) : null}

								<NavLink to='/Story' className='menu_item_m'>
									<li>STORY</li>
								</NavLink>
								<li
									onClick={() => {
										alert(textData.header.closed);
										offModal();
									}}>
									NFT MARKET
								</li>
								<NavLink to='/Gallery' className='menu_item_m'>
									<li onClick={offModal}>GALLERY</li>
								</NavLink>
								<NavHashLink
									style={{ textDecoration: 'none' }}
									to='/about/#roadMap'
									className='menu_item_m'>
									<li onClick={offModal}>ROADMAP</li>
								</NavHashLink>
								{!isConnected ? (
									<div className='wallet_box_m'>
										<div
											className='wallet_btn_m'
											onClick={() => {
												// setModalopen(true);
												// logoutFuc();
												handleAuth();
												setOpenMenu(false);
											}}>
											<p>Login</p>
										</div>
									</div>
								) : (
									<div className='account_box_m'>
										{/* <div className="account_wallet" onClick={() => { setWalletConnectModal(true); }}>
                      <p>Connect Wallet</p>
                    </div> */}
										<div
											className='account_menu_m'
											onClick={() => {
												_myPageRoute();
												setOpenMenu(false);
											}}>
											<img src={mypage_ico} />
											<p>My Page</p>
										</div>
										<div
											className='account_menu_m'
											onClick={() => {
												logoutFuc();
											}}>
											<img src={logout_ico} />
											<p>Log Out</p>
										</div>
									</div>
								)}
							</ul>
						</div>
					) : null}
				</div>
			</>
		);
	}
);

export default HeaderMobile;
